"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var TeamContactFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_TeamContactFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4a4 4 0 0 1 4-4h7a4 4 0 0 1 4 4h.501a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H15v4h.501a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H15a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Zm5.5 3.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5ZM2 10.6c0-1.16 1.4-2.1 3.5-2.1 1.154 0 2.097.284 2.712.732.075.055.144.111.209.17.373.34.58.753.58 1.198a1.4 1.4 0 0 1-1.119 1.372l-.02.003H7.86A1.444 1.444 0 0 1 7.6 12H3.4A1.4 1.4 0 0 1 2 10.6Zm7.943-2.537a1.531 1.531 0 1 0 0-3.063 1.531 1.531 0 0 0 0 3.063Zm.124 2.537c0-.631-.235-1.19-.603-1.643.154-.013.313-.02.477-.02 1.132 0 2.032.313 2.556.79.326.297.507.658.507 1.048A1.225 1.225 0 0 1 11.779 12H9.63c.275-.398.436-.88.436-1.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_TeamContactFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = TeamContactFill;
exports["default"] = _default;